import { createContext, useContext } from 'react';

/** React Context to manage Inv tran data */
export const TransactionsDataContext = createContext({});

/** Custom Hook to access the TransactionData Context */
export const useTransactionsDataContext = () => useContext(TransactionsDataContext);
